import React from 'react';
import { MdDeleteForever, MdEdit } from 'react-icons/md';

// helper function to format numbers to 2 decimal places
// ? ternary operator checks if x is a finite number before formatting
// else returns empty string
const fmt2 = (x) => {
  const n = Number(x);
  if (!Number.isFinite(n)) return "";

  // hide zeros
  if (n === 0) return "";
  return n.toFixed(2);
};

// this represents a single row in the weight and balance table
function WtBalRow({ 
  wbal, 
  onDelete, 
  onEdit, 
  initialFuelGal, 
  setInitialFuelGal,
  runupFuelGal,
  setRunupFuelGal, 
  canEdit = false,
}) {
  // pulls from imported wbal object the kind property
  // ? ternary operator checks if wbal is not null or undefined
  const kind = wbal?.kind || "normal";

     

  let stationCell = wbal.id;

  if (kind === "fuel_initial") {
    stationCell = (
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <span style={{ 
          fontWeight: "bold", 
          fontSize: "20px" 
          }}>Total Fuel</span>

        <input
          style={{ 
            width: 90, 
            textAlign: "center",
            fontSize: "22px",
            fontWeight: "bold",
            padding: "4px 6px",
          }}
          value={initialFuelGal}
          onChange={(e) => setInitialFuelGal(e.target.value)}
        />
        <span style={{ 
          fontWeight: "bold", 
          fontSize: "20px" 
          }}>(gallons)</span>
      </div>
    );
  }

  if (kind === "fuel_runup") {
    stationCell = (
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <span style={{ 
          fontWeight: "bold", 
          fontSize: "20px" 
          }}>Runup Fuel
          </span>
        <input 
        style={{
          width: 90,
          textAlign: "center",
          fontSize: "22px",
          fontWeight: "bold",

        }} 
        value={runupFuelGal} 
        onChange={(e) => setRunupFuelGal(e.target.value)}
        />
        <span style={{ 
          fontWeight: "bold", 
          fontSize: "20px" 
          }}>(gallons)
          </span>
      </div>
    );
  }

  if (kind === "fuel_takeoff") {
    stationCell = (
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
         <span style={{ 
          fontWeight: "bold", 
          fontSize: "22px",
          }}>Takeoff Total Fuel = 
          </span>
        <span style={{
          fontWeight: "bold", 
          fontSize: "22px",
        }}>{wbal.galValue}</span>
         <span style={{ 
          fontWeight: "bold", 
          fontSize: "20px",
          }}>(gallons)
          </span>
      </div>
    );
  } 
  if (kind === "fuel_takeoff_usable") {
  stationCell = (
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      <span style={{ fontWeight: "bold", fontSize: "22px" }}>
        Takeoff Usable Fuel =
      </span>
      <span style={{ fontWeight: "bold", fontSize: "22px" }}>
        {wbal.galValue}
      </span>
      <span style={{ fontWeight: "bold", fontSize: "20px" }}>
        (gallons)
      </span>
    </div>
    );
  }
      if (kind === "fuel_unusable") {
        stationCell = (
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <span style={{ fontWeight: "bold", fontSize: "22px" }}>
              Unusable Fuel =
            </span>
            <span style={{ fontWeight: "bold", fontSize: "22px" }}>
              {wbal.galValue}
            </span>
            <span style={{ fontWeight: "bold", fontSize: "20px" }}>
              (gallons)
            </span>
          </div>
        );
      }

    if (kind === "sum_total") {
      stationCell = (
        <span style={{ fontWeight: "bold", fontSize: "22px" }}>
          Takeoff Sum Weights and Moments
        </span>
      );
    }


  if (kind === "cg_info") {
    const cgTxt = fmt2(wbal.cgIn);

    stationCell = (
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      <span style={{ fontWeight: "bold", fontSize: "22px" }}>
      Takeoff CG={cgTxt} 
      </span>
      <span style={{ fontWeight: "bold", fontSize: "20px" }}>
        inches
      </span>
      </div>
    );
  }
    const isFuelRow =
        kind === "fuel_initial" ||
        kind === "fuel_runup" ||
        kind === "fuel_takeoff"||
        kind === "fuel_takeoff_usable"||
        kind === "fuel_unusable";

        const isSumRow = kind === "sum_total";
        const isNormalRow = kind === "normal";
        const weight =
            wbal.Weight === "" || wbal.Weight == null
              ? ""
              : fmt2(wbal.Weight);

        const arm =
            isSumRow || wbal.Arm === "" || wbal.Arm == null
              ? ""
              : fmt2(wbal.Arm);

        const moment =
            wbal.momentLbIn === "" || wbal.momentLbIn == null
              ? ""
              : fmt2(wbal.momentLbIn);


      if (wbal?.kind === "sum_total") {
      console.log("WbalRow: SUM TOTAL ROW:", wbal);
    }

   return (
    <tr>
      <td className='station_box'>{stationCell}</td>
      <td className='weight3_box'>{weight}</td>

      {/* CHANGE HERE:
          keep plain arm text, no input box */}
      <td className='arm_box'>{arm}</td>

      <td className='moment_box'>{moment}</td>

      {/* CHANGE HERE:
          replace your old showActions block with this whole block */}
      {isNormalRow ? (
        <>
        {canEdit && (
          <td>
            <MdEdit onClick={() => onEdit(wbal)} />
          </td>
        )}
          {canEdit && (
          <td>
            <MdDeleteForever onClick={() => onDelete(wbal.id || wbal._id)} />
          </td>
        )}
        </>
      ) : isFuelRow ? (
        <>
          <td>
            <MdEdit onClick={() => onEdit(wbal)} />
          </td>
          <td />
        </>
      ) : (
        <>
          <td />
          <td />
        </>
      )}
    </tr>
  );
}


export default WtBalRow;